<template>
  <ul class="student-style flex-layout" >
        <li class="style-li" 
            v-for="(item, index) in list" 
            :key="index"
            :style="marginBottom"
            :class="calcStyle"
            @click="toPage(item.id)">
            <img :src="item.cover" alt="">
            <p class="wes">{{item.title}}</p>
        </li>
  </ul>
</template>

<script>
export default {
    props: {
        cloumn: {
          type:Number
        },
        margin:{
          type:Number
        }
    },
    data() {
        return {
            marginBottom:{
                marginBottom: this.margin ? this.margin+'px' : 0
            },
            list:[],
        }
    },
    computed:{
        calcStyle:function() {
            let lof = 'u-lof'
            this.cloumn ? lof = 'u-lof' + String(this.cloumn) : lof = lof +'4'
            return lof;
        }  
    },
    methods: {
        async getStyleList(){
            let params = {
                isAsc:'desc',
                pageNum:1,
                pageSize:6
            }
            let resData = await Api.News.GetStudentStyle(params);
            this.list = resData.rows;
            console.log(resData);
        },
        toPage(id){
             Common.goPage(`/news/style/detail/${id}`,this)
        }
    },
    mounted(){
        this.getStyleList();
    }
}
</script>

<style lang="less" scoped>
    .student-style {
        flex-flow: row wrap;
        align-content: flex-start;
        
        

        // &:after { 
        //     content: " "; 
        //     flex: auto;
        // } 

        .u-lof4 {
            flex: 0 0 24%;
            max-width: 24%;
             &:nth-child(4n) {
                margin-right: 0;
            }
        }

        .u-lof3 {
            flex: 0 0 33%;
            max-width: 33%;
             &:nth-child(3n) {
                margin-right: 0;
            }
        }

        .u-lof2 {
            flex: 0 0 49%;
             &:nth-child(2n) {
                margin-right: 0;
            }
        }
        
        li {
            display: block;
            margin-right: 16px;
            max-width: 288px;
            cursor: pointer;

            &:hover p {
                color: #fff;
                background-color: #1c4b90;
            }
        }

        img {
            display: block;

            width: 100%;
            height: 161px;

            background-color: #1c4b90;
        }
        p {
            padding-left: 20px;

            font-size: 16px;

            color: #333;
            line-height: 41px;
        }

        
    }
</style>